window.screenPasskey = (function () {
    function logPrefix(scope) {
        return `[screenPasskey:${scope}]`;
    }

    function previewValue(value, maxLength = 120) {
        try {
            if (value === null) return "null";
            if (value === undefined) return "undefined";

            if (typeof value === "string") {
                return value.length > maxLength
                    ? value.substring(0, maxLength) + `... (len=${value.length})`
                    : value;
            }

            if (value instanceof Uint8Array) {
                return `Uint8Array(len=${value.length})`;
            }

            if (value instanceof ArrayBuffer) {
                return `ArrayBuffer(byteLength=${value.byteLength})`;
            }

            const json = JSON.stringify(value);
            return json.length > maxLength
                ? json.substring(0, maxLength) + `... (len=${json.length})`
                : json;
        } catch (e) {
            return `[preview failed: ${e?.message || e}]`;
        }
    }

    function inspectEncodedValue(name, value) {
        try {
            console.log(`${logPrefix("inspect")} ${name}`, value);
            console.log(`${logPrefix("inspect")} ${name} typeof:`, typeof value);
            console.log(`${logPrefix("inspect")} ${name} is null:`, value === null);
            console.log(`${logPrefix("inspect")} ${name} is undefined:`, value === undefined);
            console.log(`${logPrefix("inspect")} ${name} length:`, value?.length);
            console.log(`${logPrefix("inspect")} ${name} has '-'?`, typeof value === "string" ? value.includes("-") : false);
            console.log(`${logPrefix("inspect")} ${name} has '_'?`, typeof value === "string" ? value.includes("_") : false);
            console.log(`${logPrefix("inspect")} ${name} has '+'?`, typeof value === "string" ? value.includes("+") : false);
            console.log(`${logPrefix("inspect")} ${name} has '/'?`, typeof value === "string" ? value.includes("/") : false);
            console.log(`${logPrefix("inspect")} ${name} ends with '='?`, typeof value === "string" ? value.endsWith("=") : false);
            console.log(`${logPrefix("inspect")} ${name} preview:`, previewValue(value));
        } catch (e) {
            console.error(`${logPrefix("inspect")} Failed inspecting ${name}`, e);
        }
    }

    function clone(obj) {
        try {
            const cloned = JSON.parse(JSON.stringify(obj));
            console.log(`${logPrefix("clone")} clone ok`);
            return cloned;
        } catch (e) {
            console.error(`${logPrefix("clone")} clone failed`, e, obj);
            throw e;
        }
    }

    function parseInput(input, scope) {
        try {
            console.log(`${logPrefix(scope)} raw input type:`, typeof input);
            console.log(`${logPrefix(scope)} raw input preview:`, previewValue(input, 300));

            const parsed = typeof input === "string" ? JSON.parse(input) : clone(input);

            console.log(`${logPrefix(scope)} parsed ok`, parsed);
            return parsed;
        } catch (e) {
            console.error(`${logPrefix(scope)} failed to parse input`, e);
            throw e;
        }
    }

    function base64UrlToUint8Array(base64url, fieldName) {
        const name = fieldName || "unknown";

        try {
            inspectEncodedValue(name, base64url);

            if (!base64url) {
                console.warn(`${logPrefix("decode")} ${name} was empty/falsy, returning empty Uint8Array`);
                return new Uint8Array(0);
            }

            if (typeof base64url !== "string") {
                throw new Error(`${name} is not a string. Actual type: ${typeof base64url}`);
            }

            let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
            while (base64.length % 4 !== 0) {
                base64 += "=";
            }

            console.log(`${logPrefix("decode")} ${name} normalized base64 preview:`, previewValue(base64));

            const binary = atob(base64);
            const bytes = new Uint8Array(binary.length);

            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }

            console.log(`${logPrefix("decode")} ${name} decoded successfully, byteLength=${bytes.length}`);
            return bytes;
        } catch (e) {
            console.error(`${logPrefix("decode")} FAILED decoding ${name}`, {
                errorName: e?.name,
                errorMessage: e?.message,
                value: base64url
            });
            throw e;
        }
    }

    function uint8ArrayToBase64Url(value, fieldName) {
        const name = fieldName || "unknown";

        try {
            console.log(`${logPrefix("encode")} ${name} input:`, value);

            const bytes = value instanceof ArrayBuffer
                ? new Uint8Array(value)
                : new Uint8Array(value);

            console.log(`${logPrefix("encode")} ${name} bytes length:`, bytes.length);

            let binary = "";
            for (let i = 0; i < bytes.length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }

            const base64url = btoa(binary)
                .replace(/\+/g, "-")
                .replace(/\//g, "_")
                .replace(/=+$/g, "");

            console.log(`${logPrefix("encode")} ${name} output preview:`, previewValue(base64url));
            return base64url;
        } catch (e) {
            console.error(`${logPrefix("encode")} FAILED encoding ${name}`, {
                errorName: e?.name,
                errorMessage: e?.message,
                value: value
            });
            throw e;
        }
    }

    function normalizeCreationOptions(input) {
        try {
            console.groupCollapsed(`${logPrefix("normalizeCreationOptions")} start`);

            const options = parseInput(input, "normalizeCreationOptions");

            console.log(`${logPrefix("normalizeCreationOptions")} before decode`, options);

            options.challenge = base64UrlToUint8Array(options.challenge, "creation.challenge");

            if (!options.user) {
                throw new Error("creation.user was missing");
            }

            options.user.id = base64UrlToUint8Array(options.user.id, "creation.user.id");

            if (Array.isArray(options.excludeCredentials)) {
                options.excludeCredentials = options.excludeCredentials.map((x, index) => {
                    console.log(`${logPrefix("normalizeCreationOptions")} excludeCredentials[${index}] before`, x);

                    const mapped = {
                        ...x,
                        id: base64UrlToUint8Array(x.id, `creation.excludeCredentials[${index}].id`)
                    };

                    console.log(`${logPrefix("normalizeCreationOptions")} excludeCredentials[${index}] after`, mapped);
                    return mapped;
                });
            }

            const result = { publicKey: options };

            console.log(`${logPrefix("normalizeCreationOptions")} final result`, result);
            console.groupEnd();
            return result;
        } catch (e) {
            console.error(`${logPrefix("normalizeCreationOptions")} FAILED`, {
                errorName: e?.name,
                errorMessage: e?.message,
                stack: e?.stack
            });
            console.groupEnd();
            throw e;
        }
    }

    function normalizeRequestOptions(input) {
        try {
            console.groupCollapsed(`${logPrefix("normalizeRequestOptions")} start`);

            const options = parseInput(input, "normalizeRequestOptions");

            console.log(`${logPrefix("normalizeRequestOptions")} before decode`, options);

            options.challenge = base64UrlToUint8Array(options.challenge, "request.challenge");

            if (Array.isArray(options.allowCredentials)) {
                options.allowCredentials = options.allowCredentials.map((x, index) => {
                    console.log(`${logPrefix("normalizeRequestOptions")} allowCredentials[${index}] before`, x);

                    const mapped = {
                        ...x,
                        id: base64UrlToUint8Array(x.id, `request.allowCredentials[${index}].id`)
                    };

                    console.log(`${logPrefix("normalizeRequestOptions")} allowCredentials[${index}] after`, mapped);
                    return mapped;
                });
            }

            const result = { publicKey: options };

            console.log(`${logPrefix("normalizeRequestOptions")} final result`, result);
            console.groupEnd();
            return result;
        } catch (e) {
            console.error(`${logPrefix("normalizeRequestOptions")} FAILED`, {
                errorName: e?.name,
                errorMessage: e?.message,
                stack: e?.stack
            });
            console.groupEnd();
            throw e;
        }
    }

    function serializeAttestation(credential) {
        try {
            console.groupCollapsed(`${logPrefix("serializeAttestation")} start`);
            console.log(`${logPrefix("serializeAttestation")} credential`, credential);

            let transports = [];

            try {
                if (credential.response && typeof credential.response.getTransports === "function") {
                    transports = credential.response.getTransports() || [];
                }
            } catch (e) {
                console.warn(`${logPrefix("serializeAttestation")} getTransports failed`, e);
            }

            const result = {
                id: credential.id,
                rawId: uint8ArrayToBase64Url(credential.rawId, "attestation.rawId"),
                type: credential.type,
                extensions: credential.getClientExtensionResults ? credential.getClientExtensionResults() : {},
                response: {
                    attestationObject: uint8ArrayToBase64Url(credential.response.attestationObject, "attestation.response.attestationObject"),
                    clientDataJSON: uint8ArrayToBase64Url(credential.response.clientDataJSON, "attestation.response.clientDataJSON"),
                    transports: transports
                }
            };

            console.log(`${logPrefix("serializeAttestation")} result`, result);
            console.groupEnd();
            return result;
        } catch (e) {
            console.error(`${logPrefix("serializeAttestation")} FAILED`, {
                errorName: e?.name,
                errorMessage: e?.message,
                stack: e?.stack
            });
            console.groupEnd();
            throw e;
        }
    }

    function serializeAssertion(credential) {
        try {
            console.groupCollapsed(`${logPrefix("serializeAssertion")} start`);
            console.log(`${logPrefix("serializeAssertion")} credential`, credential);

            const result = {
                id: credential.id,
                rawId: uint8ArrayToBase64Url(credential.rawId, "assertion.rawId"),
                type: credential.type,
                extensions: credential.getClientExtensionResults ? credential.getClientExtensionResults() : {},
                response: {
                    authenticatorData: uint8ArrayToBase64Url(credential.response.authenticatorData, "assertion.response.authenticatorData"),
                    clientDataJSON: uint8ArrayToBase64Url(credential.response.clientDataJSON, "assertion.response.clientDataJSON"),
                    signature: uint8ArrayToBase64Url(credential.response.signature, "assertion.response.signature"),
                    userHandle: credential.response.userHandle
                        ? uint8ArrayToBase64Url(credential.response.userHandle, "assertion.response.userHandle")
                        : null
                }
            };

            console.log(`${logPrefix("serializeAssertion")} result`, result);
            console.groupEnd();
            return result;
        } catch (e) {
            console.error(`${logPrefix("serializeAssertion")} FAILED`, {
                errorName: e?.name,
                errorMessage: e?.message,
                stack: e?.stack
            });
            console.groupEnd();
            throw e;
        }
    }

    async function createJson(options) {
        try {
            console.groupCollapsed(`${logPrefix("createJson")} start`);
            console.log(`${logPrefix("createJson")} navigator.credentials available:`, !!navigator.credentials);
            console.log(`${logPrefix("createJson")} PublicKeyCredential available:`, typeof PublicKeyCredential !== "undefined");
            console.log(`${logPrefix("createJson")} incoming options`, options);

            const normalized = normalizeCreationOptions(options);
            console.log(`${logPrefix("createJson")} normalized options`, normalized);

            const credential = await navigator.credentials.create(normalized);

            console.log(`${logPrefix("createJson")} credential returned`, credential);

            if (!credential) {
                throw new Error("No passkey was created.");
            }

            const serialized = serializeAttestation(credential);
            const json = JSON.stringify(serialized);

            console.log(`${logPrefix("createJson")} final json`, json);
            console.groupEnd();
            return json;
        } catch (e) {
            console.error(`${logPrefix("createJson")} FAILED`, {
                errorName: e?.name,
                errorMessage: e?.message,
                stack: e?.stack,
                error: e
            });
            console.groupEnd();
            throw e;
        }
    }

    async function getJson(options) {
        try {
            console.groupCollapsed(`${logPrefix("getJson")} start`);
            console.log(`${logPrefix("getJson")} navigator.credentials available:`, !!navigator.credentials);
            console.log(`${logPrefix("getJson")} PublicKeyCredential available:`, typeof PublicKeyCredential !== "undefined");
            console.log(`${logPrefix("getJson")} incoming options`, options);

            const normalized = normalizeRequestOptions(options);
            console.log(`${logPrefix("getJson")} normalized options`, normalized);

            const credential = await navigator.credentials.get(normalized);

            console.log(`${logPrefix("getJson")} credential returned`, credential);

            if (!credential) {
                throw new Error("No passkey assertion was returned.");
            }

            const serialized = serializeAssertion(credential);
            const json = JSON.stringify(serialized);

            console.log(`${logPrefix("getJson")} final json`, json);
            console.groupEnd();
            return json;
        } catch (e) {
            console.error(`${logPrefix("getJson")} FAILED`, {
                errorName: e?.name,
                errorMessage: e?.message,
                stack: e?.stack,
                error: e
            });
            console.groupEnd();
            throw e;
        }
    }

    return {
        createJson,
        getJson
    };
})();

function inspectEncodedValue(name, value) {
    try {
        console.log(`[screenPasskey:globalInspect] ${name}`, value);
        console.log(`[screenPasskey:globalInspect] ${name} type:`, typeof value);
        console.log(`[screenPasskey:globalInspect] ${name} length:`, value?.length);
        console.log(`[screenPasskey:globalInspect] ${name} has '-'?`, typeof value === "string" ? value.includes("-") : false);
        console.log(`[screenPasskey:globalInspect] ${name} has '_'?`, typeof value === "string" ? value.includes("_") : false);
        console.log(`[screenPasskey:globalInspect] ${name} has '+'?`, typeof value === "string" ? value.includes("+") : false);
        console.log(`[screenPasskey:globalInspect] ${name} has '/'?`, typeof value === "string" ? value.includes("/") : false);
        console.log(`[screenPasskey:globalInspect] ${name} ends with '='?`, typeof value === "string" ? value.endsWith("=") : false);
    } catch (e) {
        console.error(`[screenPasskey:globalInspect] failed for ${name}`, e);
    }
}